export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'name'
    },
    {
      label: '性别',
      prop: '__gender__'
    },
    {
      label: '会员账号',
      prop: 'mobile'
    },
    {
      label: '当前级别',
      prop: 'beforeLevel'
    },
    {
      label: '有效比赛场数',
      prop: 'matchCount'
    },
    {
      label: '有效比赛平均积分',
      prop: 'validScore'
    },
    {
      label: '升级时胜率(%)',
      prop: 'winRate'
    },
    {
      label: '升级条件满足时间',
      prop: 'createTime'
    }
  ]
}
